export const removeEmptyFields = <TData extends Record<string, any> = Record<string, any>>(data: TData) =>
  Object.fromEntries(Object.entries(data).filter(([, value]) => value !== "" && value != null)) as TData;
